import { render } from "./speakerDetector.vue?vue&type=template&id=6841bf8d&scoped=true"
import script from "./speakerDetector.vue?vue&type=script&lang=js"
export * from "./speakerDetector.vue?vue&type=script&lang=js"

import "./index.scss?vue&type=style&index=0&id=6841bf8d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\wjlfi\\Desktop\\1v1vue3\\demos\\basic\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6841bf8d"]])

export default __exports__